import React from "react";
import { Image, Flex } from "antd";
import useSWR from "swr";
import HelplineDataTable from "../../components/dataTable/b2b/HelplineDataTable";
import { fetcher } from "../../utils/fetcher";

const API_URL = process.env.REACT_APP_API_URL;
interface BookedSessionResponse {
  success: boolean;
  lastMonthBookedSessions: number;
  totalSessionCount: number;
  data: Contentdata[];
}

interface Contentdata {
  _id: string;
  bodyText: string;
  user_id: string;
  video_id: string;
}

function HelpLineHistory() {
  const { data: sessionRes, isLoading: sessionLoading } =
    useSWR<BookedSessionResponse>(
      `${API_URL}/session/bookedSession/`,
      fetcher,
      {
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
      }
    );

  const contentData = sessionRes?.data ?? [];
  const lastMonthCount = sessionRes?.lastMonthBookedSessions ?? 0;
  const totalSessions = sessionRes?.totalSessionCount ?? 0;

  return (
    <div className="contentBox">
      <Flex gap={16}>
        <div className="session_card">
          <Image src="/Frame.png" width={40} height={40} preview={false} />
          <Flex vertical>
            <div className="title">Total Sessions</div>
            <div className="count">{totalSessions}</div>
          </Flex>
        </div>

        <div className="session_card">
          <Image src="/calendar.png" width={40} height={40} preview={false} />
          <Flex vertical>
            <div className="title">Last Month’s</div>
            <div className="count">{lastMonthCount}</div>
          </Flex>
        </div>
      </Flex>

      <HelplineDataTable contentData={contentData} sessionLoading={sessionLoading} />
    </div>
  );
}

export default HelpLineHistory;
